import { useMutation } from '@tanstack/react-query';
import { AxiosProgressEvent } from 'axios';
import ChatService from '../services/chat.service';

const chatService = new ChatService();

/**
 * Custom hook to import documents from Google Drive.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the import.
 */
export const useImportGoogleDocument = () => {
    return useMutation({
        mutationFn: async ({
            fileId,
            parentId,
            fileName,
            externalId,
            handleProgressEvent,
        }: {
            fileId: string;
            parentId: string | null; // Parent ID can be null if not specified
            fileName: string;
            externalId: string;
            handleProgressEvent?: (event: AxiosProgressEvent & { name: string }) => void;
        }) => {
            if (!fileId || !fileName) {
                throw new Error('File ID, Parent ID, and File Name are required to import a document');
            }

            return await chatService.importDocumentsFromGoogle(
                fileId,
                parentId,
                fileName,
                externalId,
                handleProgressEvent,
            );
        },
    });
};
